import type { PaginatedLoadingContextValue } from "@tandemdiabetes/sugarmate-api-react-client"
import dayjs from "dayjs"
import { useMemo } from "react"
import type { MangoQuery } from "rxdb"
import { getTimeConstraintFromQueryObject } from "src/utils"

// this hook returns true if data that might be relevant to this query is
// still being fetched
export function useIsFetchingForQuery<T>(
  loadingContextValue: PaginatedLoadingContextValue,
  queryObject: MangoQuery<T>,
): boolean {
  const {
    loading,
    loadedBefore,
  } = loadingContextValue

  const queryTime = useMemo(
    () => getTimeConstraintFromQueryObject(queryObject),
    [queryObject],
  )

  const isFetching = (
    // if loading and we have not loaded past this query time
    loading && (queryTime === null || dayjs(queryTime).isBefore(loadedBefore))
  )

  return isFetching
}
